import {
  CreateWorkScheduleDto,
  UpdateWorkScheduleDto,
} from '../models/workSchedule/dto'
import axiosClient from './axiosClient'

const PATH = '/work-schedules'

export const workScheduleApi = {
  getWorkSchedules: () =>
    axiosClient.get(PATH, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  createWorkSchedule: (workSchedule: CreateWorkScheduleDto) =>
    axiosClient.post(
      PATH,
      {
        ...workSchedule,
        startDate: new Date(
          new Date(workSchedule.startDate).setHours(0, 0, 0, 0)
        ).getTime(),
        endDateDate: new Date(
          new Date(workSchedule.endDate).setHours(23, 59, 59, 999)
        ).getTime(),
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    ),

  updateWorkSchedule: (id: number, workSchedule: UpdateWorkScheduleDto) =>
    axiosClient.put(`${PATH}/${id}`, workSchedule, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  deleteWorkSchedule: (id: number) =>
    axiosClient.delete(`${PATH}/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),
}
